import { c as _c } from "react/compiler-runtime";
// Third Party
import * as React from 'react';

// Utils
import { routes } from '@routes';
import { SearchPageContentType } from '@gql';

// UI
import { NewsletterForm } from '@components/newsletter-form';
import { FooterSections } from '@components/footer-sections';
import { FooterSocial } from '@components/footer-social';
import { CookieSettingsButton } from '@components/cookie-consent-banner';
interface FooterLink {
  href: string;
  name: string;
  rel?: string;
}
const bottomFooterLinks: FooterLink[] = [{
  href: routes.privacy,
  name: 'Privacy',
  rel: 'nofollow'
}, {
  href: routes.terms,
  name: 'Terms',
  rel: 'nofollow'
}, {
  href: routes.sitemaps(SearchPageContentType.VacationRental),
  name: 'Site Map',
  rel: 'nofollow'
}];

// Shared styles for all bottom footer links to ensure visual consistency
const footerLinkStyles = 'text-sm font-sans font-bold text-primary-main underline hover:text-primary-dark cursor-pointer';
export interface FooterProps {
  /**
   * Visual treatment for the footer card background. `default` is the
   * site-wide teal (`bg-primary-dark`). `independence` swaps in the deep
   * navy used by the 4th of July campaign landing page (BHT-6346).
   */
  variant?: 'default' | 'independence';
}
const footerCardBackgroundByVariant: Record<NonNullable<FooterProps['variant']>, string> = {
  default: 'bg-primary-dark',
  independence: 'bg-independence-navy'
};
export const Footer: React.FC<FooterProps> = t0 => {
  const $ = _c(9);
  const {
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "default" : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div id="footer-heading" className="sr-only">Footer</div>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const t3 = `rounded-2xl ${footerCardBackgroundByVariant[variant]} p-8 sm:p-12  sm:pb-[34px] text-secondary-main`;
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <FooterSections />;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <FooterSocial showNewsletter={true}><NewsletterForm /></FooterSocial>;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== t3) {
    t6 = <div className={t3}>{t4}{t5}</div>;
    $[3] = t3;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <p className="text-sm text-primary-main sm:mb-0">© finderco, LLC all rights reserved.</p>;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="my-4 flex flex-col items-center justify-center gap-4 sm:flex-row lg:justify-end">{t7}<div className="flex flex-wrap items-center justify-center gap-4">{bottomFooterLinks.map(_temp)}<CookieSettingsButton className={`appearance-none bg-transparent border-0 p-0 ${footerLinkStyles}`}>Cookie Settings</CookieSettingsButton></div></div>;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] !== t6) {
    t9 = <footer aria-labelledby="footer-heading" className="body-container mt-6">{t2}{t6}{t8}</footer>;
    $[7] = t6;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  return t9;
};
function _temp(item) {
  return <a key={item.name} href={item.href} rel={item.rel} className={footerLinkStyles}>{item.name}</a>;
}